import { render, staticRenderFns } from "./IconLang.vue?vue&type=template&id=58d3d87c&"
import script from "./IconLang.vue?vue&type=script&lang=js&"
export * from "./IconLang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports